import { BuildingIcon } from 'lucide-react';

import { cn } from 'src/lib/utils';

type Props = {
  className?: string;
};

const CompanyIcon = ({ className }: Props) => {
  return <BuildingIcon className={cn('text-foreground', className)} />;
};

export default CompanyIcon;
